import { styled } from '@mui/material/styles';

export const GeneralViewPortWrapper = styled('div')`
	width: 100%;
	height: 100%;
	min-height: calc(100vh);
	display: flex;
	flex-direction: column;
`;

export const Wrapper = styled('div')`
`;